import { type MarkerType, type PositionHistoryClickItem } from '#/types/messages/positions-history-payload.types';

import { type ChartSize, DeviceType, type IosPayload, type LineDragEndPayload, ParentApp } from './device.types';

export class IosTradingService extends ParentApp {
  serviceName = 'IosTradingService';

  isDevice(device: DeviceType): boolean {
    return device === DeviceType.IosNative;
  }

  protected get control() {
    return window.webkit?.messageHandlers?.iOSNative?.postMessage?.bind(window.webkit?.messageHandlers?.iOSNative);
  }

  onAppReadyListenMessages() {
    const payload: IosPayload = {
      command: 'onTradingViewChartLoaded',
    };

    this.control?.(payload);
  }

  setChartSize(size: ChartSize) {
    const payload: IosPayload = {
      command: 'setChartSize',
      value: size,
    };

    return this.control?.<ChartSize>(payload);
  }

  openUiElementsDisplayConfiguration() {
    const payload: IosPayload = {
      command: 'openTradeConfiguration',
    };

    this.control?.(payload);
  }

  onHmrInfoButtonPressed() {
    const payload: IosPayload = {
      command: 'hmrIconPressed',
    };

    this.control?.(payload);
  }

  onPositionsHistoryMarkerPressed(positions: PositionHistoryClickItem[], markerType: MarkerType) {
    const payload: IosPayload = {
      command: 'positionsHistoryMarkerPressed',
      value: positions,
      markerType,
    };

    this.control?.(payload);
  }

  requestPositionsHistory(range: { from: number; to: number }) {
    const payload: IosPayload = {
      command: 'requestPositionsHistory',
      value: range,
    };

    this.control?.(payload);
  }

  onLineDragEnd(payload: LineDragEndPayload): void {
    const iosPayload: IosPayload = {
      command: 'onLineDragEnd',
      value: payload,
    };

    this.control?.(iosPayload);
  }

  onSymbolChanged(symbol: string) {
    const payload: IosPayload = {
      command: 'symbolChanged',
      value: symbol,
    };

    this.control?.(payload);
  }
}
